module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_foreword#_idTextAnchor001"
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("Foreword by Wesley Hill")]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_prelude#_idTextAnchor002"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PRELUDE: PROMISES")])])]), _vm._v(" "), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/08_ch1#_idTextAnchor003"
    }
  }, [_vm._v("1 Revelation")]), _vm._v(" "), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/09_ch2#_idTextAnchor004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Almost Straight")]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/10_ch3#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Debating the Divine")]), _vm._v(" "), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/11_ch4#_idTextAnchor006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 What God Called Good")]), _c('i', {
    staticClass: "TOC_page_no"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_interlude#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("INTERLUDE: A SONG FOR THE UNKNOWING\t")])])]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/13_ch5#_idTextAnchor008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Stranger Incognito")]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/14_ch6#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 To Know as I Am Known")]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/15_ch7#_idTextAnchor010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Nature Abhors a Vacuum")]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', {
    staticClass: "TOC_chpt_no"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/16_ch8#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Quo Vadis?")]), _vm._v(" "), _c('i', {
    staticClass: "TOC_page_no"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_postlude#_idTextAnchor012",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "sans"
  }, [_vm._v("POSTLUDE: A LETTER TO MYSELF AT AGE TWELVE")])])]), _c('i', {
    staticClass: "TOC_page_no"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_acknowledgments#_idTextAnchor013",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "TOC_page_no"
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_praise#_idTextAnchor014",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("Praise for ")]), _vm._v("Single, Gay, Christian")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_author#_idTextAnchor015",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_moreIVP#_idTextAnchor016",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("More Titles from InterVarsity Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/03_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("Copyright")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdbbaf78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_contents.vue
// module id = 63
// module chunks = 0